import React from 'react';
import { Icon, Step } from 'semantic-ui-react'

const ClaimSubmissionStep = ({ stepIndex, setIndex }) => {
    return (
        <Step.Group attached='top'>
            <Step onClick={() => setIndex(1)} active={(stepIndex === 1) ? true : false} completed={stepIndex > 1}>
                <Icon name='truck' />
                <Step.Content>
                    <Step.Title>Type of Claim</Step.Title>
                    <Step.Description>Choose your claim type</Step.Description>
                </Step.Content>
            </Step>

            <Step active={stepIndex === 2} completed={stepIndex > 2}>
                <Icon name='payment' />
                <Step.Content>
                    <Step.Title>Claim Information</Step.Title>
                    <Step.Description>Enter claim information</Step.Description>
                </Step.Content>
            </Step>

            <Step active={stepIndex === 3} completed={stepIndex > 3}>
                <Icon name='info' />
                <Step.Content>
                    <Step.Title>Confirm Claim</Step.Title>
                    <Step.Description>Final check before submission</Step.Description>
                </Step.Content>
            </Step>
        </Step.Group>
    );
}

export default ClaimSubmissionStep;